import axios from 'axios';
import config from '../../config/environment';
import authService from './authService';

// Konfiguracja bazowego klienta HTTP
const apiClient = axios.create({
  baseURL: config.API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor dla requestów
apiClient.interceptors.request.use(
  async (requestConfig) => {
    const token = localStorage.getItem(config.STORAGE_KEYS.ACCESS_TOKEN);
    
    if (token) {
      // Sprawdź czy token wygasa za 5 minut
      if (authService.isTokenExpiringSoon(token)) {
        try {
          await authService.refreshAccessToken();
          // Pobierz nowy token
          const newToken = localStorage.getItem(config.STORAGE_KEYS.ACCESS_TOKEN);
          requestConfig.headers.Authorization = `Bearer ${newToken}`;
        } catch (error) {
          console.error('Błąd podczas odświeżania tokenu:', error);
          // Jeśli refresh się nie udał, przekaż request z obecnym tokenem
          requestConfig.headers.Authorization = `Bearer ${token}`;
        }
      } else {
        requestConfig.headers.Authorization = `Bearer ${token}`;
      }
    }
    
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

// Interceptor dla responsów
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.error('API Error:', error.response?.data || error.message);
    
    if (error.response?.status === 401) {
      // Don't redirect for auth endpoints to avoid infinite loops
      const isAuthEndpoint = error.config?.url?.includes('/auth/');
      if (!isAuthEndpoint) {
        // Spróbuj odświeżyć token przed przekierowaniem
        try {
          await authService.refreshAccessToken();
          // Jeśli refresh się udał, powtórz oryginalny request
          const originalRequest = error.config;
          const newToken = localStorage.getItem(config.STORAGE_KEYS.ACCESS_TOKEN);
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return apiClient(originalRequest);
        } catch (refreshError) {
          console.error('Nie udało się odświeżyć tokenu:', refreshError);
          // Clear tokens and redirect to login on 401
          localStorage.removeItem(config.STORAGE_KEYS.ACCESS_TOKEN);
          localStorage.removeItem(config.STORAGE_KEYS.REFRESH_TOKEN);
          window.location.href = '/login';
        }
      }
    }
    
    if (error.response?.status === 500) {
      console.error('Server error:', error.response.data);
    }
    
    return Promise.reject(error);
  }
);

export default apiClient; 